
import { computed, defineComponent, toRefs, ref, SetupContext } from 'vue';
import iconMap from './../../assets/icon';
import { validatorByIconTheme, validatorByIconSize } from './../../utils/validator';

export default defineComponent({
  name: 'TIcon',
  props: {
    /** 组件默认名称 */
    iconName: {
      type: String,
      default: () => 'more',
      validator: (value: string) => Object.keys(iconMap).includes(value),
    },
    /** 组件透明度(默认为0, 表示直接使用样式定义好的透明度) */
    opacity: {
      type: Number,
      default: () => 0,
    },
    /** 组件的颜色别名 */
    theme: {
      type: String,
      default: () => 'default',
      validator: (value: string) => validatorByIconTheme(value),
    },
    /** 组件的尺寸别名 */
    size: {
      type: String,
      default: () => 'medium',
      validator: (value: string) => validatorByIconSize(value),
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    // 定义组件类型前辍
    const prefixCls = ref('t-icon');

    /** 组件依赖的className */
    const getClasses = computed(() => [
      prefixCls.value,
      `${prefixCls.value}-${props.theme}`,
      `${prefixCls.value}-size__${props.size}`,
      `${prefixCls.value}__${props.iconName}`,
    ]);

    // 定义组件依赖的style
    const getStyles = computed(() => {
      if (props.opacity) {
        return {
          opacity: props.opacity,
        };
      }
      return;
    });

    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, getStyles, listener };
  },
});
